import { render, staticRenderFns } from "./QCApplicant.vue?vue&type=template&id=33820ecb"
import script from "./QCApplicant.vue?vue&type=script&lang=js"
export * from "./QCApplicant.vue?vue&type=script&lang=js"
import style0 from "./QCApplicant.vue?vue&type=style&index=0&id=33820ecb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports